if (!customElements.get("sale-tips")) {
  customElements.define(
    "sale-tips",
    class SaleTips extends HTMLElement {
      constructor() {
        super();
        this.html = this.querySelector(".sale-tips-html");
        this.discountedPrice = this.querySelector(".discounted-product-price");
        this.discountedText = this.querySelector(".discounted-text");
        this.addEventListener("variant:change", () => {
          this.calculativePrice();
        });
      }
      connectedCallback() {
        this.calculativePrice();
      }
      // 价格保留两位小数函数
      truncateDecimals(number, digits) {
        const multiplier = Math.pow(10, digits);
        return Math.floor(number * multiplier) / multiplier;
      }

      calculativePrice() {
        // 获取折扣
        // [deprecated]
        // const discountMatch =
        //   $(this)
        //     .find("p")
        //     .text()
        //     .match(/(\d+)%/)[1] / 100;
        const save = this.dataset.save;
        let discountPercent = 0;
        let discountAmout = 0;
        if (save.indexOf("%") != -1 ) {
          discountPercent = save.replace("%", "") / 100;
        } else {
          discountAmout = Number.parseFloat(save);
        }
        // 获取产品原价=
        const originalPrice =
          Shopify?.currency?.active == "EUR"
            ? Number(
                $(this)
                  .find(".geolizr-currency")
                  .text()
                  .replace(".", "")
                  .match(/[\d,]+/)[0]
                  .replace(",", ".")
              )
            : Number(
                $(this)
                  .find(".geolizr-currency")
                  .text()
                  .replace(",", "")
                  .match(/[\d.]+/)[0]
              );

        // console.log("originalPrice", originalPrice, $(this).find(".geolizr-currency").text().replace(".", ""),$(this).find(".geolizr-currency").text().replace(".", "").match(/[\d,]+/));

        // 获取价格货币符号
        const symbol = $(this)
          .find(".geolizr-currency")
          .text()
          .replace(/[\d.,]+/g, "");

        // 节省的价格
        const savePrice =
          discountPercent > discountAmout
            ? this.truncateDecimals(originalPrice * discountPercent, 2)
            : this.truncateDecimals(discountAmout, 2);

        // 产品折扣后的价格
        let discountPrice = (originalPrice - savePrice).toFixed(2);

        if (Shopify?.currency?.active == "EUR") {
          // console.log('replace Alllllllllllllllllllllllllllllllllllllll');
          discountPrice = discountPrice.toString();
          discountPrice = discountPrice.replaceAll(",", "*");
          discountPrice = discountPrice.replaceAll(".", ",");
          discountPrice = discountPrice.replaceAll("*", ".");
        }

        this.discountedPrice.innerHTML = symbol + discountPrice;
        this.discountedText.classList.remove("hidden");
        // console.log(
        //   "discountPrice",
        //   discountPrice,
        //   "savePrice",
        //   savePrice,
        //   "originalPrice",
        //   originalPrice,
        //   "discountMatch",
        //   discountMatch
        // );
      }
    }
  );
}
